import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Container } from '@pinpoint/design-kit';

import { onboardingActions, modelViewActions } from 'src/store/actions';
import { Page } from 'src/containers';

import { ButtonNav, InputDistribution } from 'src/components/onboarding';

function OnboardingView({
  email,
  history,
  location: { search, pathname },
  match: {
    params: { onbId },
  },
  dataset,
  onboarding,
  preMatchInputDistUrl,
  fetchPreMatchInputDistUrl,
  getDataset,
  getOnboarding,
  unset,
}) {
  useEffect(() => {
    getOnboarding(onbId);
  }, [getOnboarding, onbId]);

  useEffect(() => {
    if (onboarding?.dataset_id) {
      getDataset(onboarding?.dataset_id);
      fetchPreMatchInputDistUrl(onboarding?.dataset_id, 'dataset');
    }
  }, [getDataset, fetchPreMatchInputDistUrl, onboarding]);

  if (dataset)
    return (
      <Container
        d="flex"
        flexDir="column"
        w="100%"
        minW="100%"
        maxW="100%"
        h="100%"
        minH="100%"
        maxH="100%"
        data-debug="onb-view-cntr"
      >
        <ButtonNav
          goTo={history.push}
          unset={unset}
          onbId={onbId}
          mode="view"
          title="Pre-Match Input Distributions"
          preMatchInputDistUrl={preMatchInputDistUrl}
        />
        <InputDistribution
          history={history}
          onpointDataset={dataset}
          queryParams={search}
          email={email}
          pathname={pathname}
        />
      </Container>
    );
  return null;
}

const mapStateToProps = (
  {
    app: {
      tenant,
      profile: { email },
    },
    onboarding: { dataset, onboarding },
    modelView: { preMatchInputDistUrl },
  },
  ownProps
) => ({
  ...ownProps,
  email,
  dataset,
  onboarding,
  preMatchInputDistUrl,
});

const mapDispatchToProps = (dispatch) => ({
  getOnboarding: (id) => dispatch(onboardingActions.getOnboarding(id)),
  getDataset: (id) => dispatch(onboardingActions.getDataset(id)),
  fetchPreMatchInputDistUrl: (entityId, entityType) =>
    dispatch(modelViewActions.fetchInputDistDownloadUrl(entityId, entityType)),
  unset: (key) => dispatch(onboardingActions.unset(key)),
});

OnboardingView.propTypes = {
  email: PropTypes.string.isRequired,
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
  preMatchInputDistUrl: PropTypes.oneOf([undefined, null, PropTypes.string]).isRequired,
  dataset: PropTypes.shape({}).isRequired,
  onboarding: {
    dataset_id: PropTypes.oneOf([PropTypes.number, undefined]).isRequired,
  }.isRequired,
  unset: PropTypes.func.isRequired,
  getOnboarding: PropTypes.func.isRequired,
  getDataset: PropTypes.func.isRequired,
  fetchPreMatchInputDistUrl: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Page(OnboardingView));
